module.exports = __webpack_public_path__ + "img/er_code.63587adf.jpg";